import { composeParsers } from 'style-utils/core/createExtractCssFromProps/utils/composeParsers';
import { WithWidthProps, withWidth } from './withWidthProps';
import { WithHeightProps, withHeight } from './withHeightProps';
import { WithSpacingProps, withSpacing } from './withSpacingProps';
import { CSSProperties } from 'styled-components';
import { WithPositionProps, withPosition } from './withPosition';
import { WithBackgroundProps, withBackground } from './withBackgroundProps';
import { WithBorderProps, withBorder } from './withBorderProps';
import { WithShadowProps, withShadow } from './withShadowProps';
import { WithColorProps, withColor } from './withColorProps';
import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';

const baseLayoutPropertiesMapping = {
  d: {
    property: 'display',
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  verticalAlign: true,
  opacity: true,
  cursor: true,
};

type WithBaseLayoutProps = {
  d?: StyledPropType<CSSProperties['display']>;
  overflow?: StyledPropType<CSSProperties['overflow']>;
  overflowX?: StyledPropType<CSSProperties['overflowX']>;
  overflowY?: StyledPropType<CSSProperties['overflowY']>;
  verticalAlign?: StyledPropType<CSSProperties['verticalAlign']>;
  opacity?: StyledPropType<CSSProperties['opacity']>;
  cursor?: StyledPropType<CSSProperties['cursor']>;
};

export type WithLayoutProps = WithBaseLayoutProps &
  WithSpacingProps &
  WithWidthProps &
  WithHeightProps &
  WithPositionProps &
  WithBackgroundProps &
  WithColorProps &
  WithBorderProps &
  WithShadowProps;

const baseLayout = createExtractCssFromProps(baseLayoutPropertiesMapping);

export const withLayout = composeParsers(
  baseLayout,
  withSpacing,
  withWidth,
  withHeight,
  withPosition,
  withBackground,
  withColor,
  withBorder,
  withShadow,
);
